import { IApplicationState } from '../../types/redux';

export function selectIsRegionSelected(state: IApplicationState) {
  return state.geoLocation.isRegionSelected;
}
